import React, { Component } from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';

import { MasterPageHeader } from '../components/PageHeader';
import Tippy from '../components/ReactTippy';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListItemChild,
  FormListItemGroup,
} from '../components/CommonFormComponents';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import LocalStorageService from '../services/utilities/LocalStorageService';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';
import { UserMailSettingsService } from '../services/UserMailSettings';
import _dialogLoader from '../utilities/dialogLoader';
import { FormInformationDialog } from '../components/FormInformationDialog';

const RADIO_STATUS = [
  {
    label: 'ON',
    value: 0,
  },
  {
    label: 'OFF',
    value: 1,
  },
];

export class UserProfileSettingMail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: [],
    };
    this.userId = LocalStorageService.getUserId();
    this.isSubmitingFlag = false;
  }

  componentDidMount() {
    this.getConfigMail();
  }

  getConfigMail = async () => {
    const response = await UserMailSettingsService.list();
    if (response.result) {
      let settings = _.get(response, 'data.entities.user_mail_settings');
      this.setState({ settings });
    }
  };

  onChange = (index, value) => {
    const settings = _.cloneDeep(this.state.settings);
    const data = _.get(settings, index);
    data.sendmail_off_flag = parseInt(value);
    _.forEach(data.children, item => {
      item.sendmail_off_flag = parseInt(value);
    });
    this.setState({ settings });
  };

  submit = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const userMailSettings = [];
    _.forEach(this.state.settings, item => {
      if (_.get(item, 'mail_group.configurable_flag')) {
        const data = _.pick(item, ['mail_group_id', 'sendmail_off_flag']);
        if (!_.isEmpty(item.children)) {
          data.children = [];
          _.forEach(item.children, itemChild => {
            if (_.get(itemChild, 'mail_group.configurable_flag')) {
              data.children.push(_.pick(itemChild, ['mail_group_id', 'sendmail_off_flag']));
            }
          });
        }
        userMailSettings.push(data);
      }
    });
    const params = {
      user_mail_settings: userMailSettings,
    };
    const data = await UserMailSettingsService.updateUserMailSettings(params);
    this.isSubmitingFlag = false;
    if (data.result) {
      return _dialogLoader.show(FormInformationDialog, {
        onClose: () => {
          _dialogLoader.close();
        },
        title: 'メール受信設定更新完了',
        message: 'メール受信設定の更新が完了しました。',
      });
    }
    _dialogLoader.show(FormInformationDialog, {
      onClose: () => {
        _dialogLoader.close();
      },
      title: 'メール受信設定の更新に失敗しました',
      message:
        'メール受信設定の更新に失敗しました。再度、メール受信設定操作を行ってください。',
    });
  };

  renderLabelMailGroup = mailGroup => (
    <React.Fragment>
      {mailGroup.name}
      {mailGroup.description && (
        <Tippy
          duration={10}
          distance={24}
          arrow={true}
          arrowType='sharp'
          delay={[500, 0]}
          placement='top'
          followCursor={true}
          html={
            <div className='permission-tooltip'>{mailGroup.description}</div>
          }
        >
          <i className='i-question--tooltip i-question--grey' />
        </Tippy>
      )}
    </React.Fragment>
  );

  renderElementMailGroup = (item, index) => {
    return !item.mail_group.configurable_flag ? (
      <FormElement info={`※${item.mail_group.name}の設定は変更できません。`}>
        <span>ON</span>
      </FormElement>
    ) : (
      <FormElement>
        <div className='form-list-radio'>
          {_.map(RADIO_STATUS, status => (
            <div className='form-list-radio__item' key={status.value}>
              <RadioButton
                name={`mail-group-${item.mail_group_id}`}
                label={status.label}
                value={status.value}
                onChange={() => this.onChange(index, status.value)}
                checked={item.sendmail_off_flag === status.value}
              />
            </div>
          ))}
        </div>
      </FormElement>
    );
  };

  renderConfigMail = () => {
    return (
      <FormList>
        <p className='UserProfileSettingMail__description'>
          Buildeeから受信するメールの種類を変更することができます。
          <br />
          「OFF」を選択されていた場合でも特に重要なお知らせについては送信させていただくことがございますのでご了承ください。
          <br />
        </p>
        {_.map(this.state.settings, (item, index) => {
          const { children } = item;
          const isLastItem = index === this.state.settings.length - 1;
          //Show children when has children and being setting ON
          const isShowChildren =
            !_.isEmpty(children) &&
            item.sendmail_off_flag === RADIO_STATUS[0].value;
          return (
            <React.Fragment key={`mail-group-${index}`}>
              <FormListItem
                label={this.renderLabelMailGroup(item.mail_group)}
                isBorder={!isShowChildren}
              >
                {this.renderElementMailGroup(item, index)}
              </FormListItem>
              {isShowChildren && (
                <FormListItemGroup isBorder={false}>
                  {_.map(children, (itemChild, indexChild) => (
                    <FormListItemChild
                      label={this.renderLabelMailGroup(itemChild.mail_group)}
                      key={indexChild}
                    >
                      {this.renderElementMailGroup(itemChild, [
                        index,
                        'children',
                        indexChild,
                      ])}
                    </FormListItemChild>
                  ))}
                  {isLastItem && (
                    <FormListItem className='form-list__item form-list__item--open' />
                  )}
                </FormListItemGroup>
              )}
            </React.Fragment>
          );
        })}
      </FormList>
    );
  };

  render() {
    return (
      <div
        id='slide-view'
        className='contruction-slide-view show UserProfileSettingMail'
      >
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - アカウント詳細・編集</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title='アカウント詳細・編集'
            onClose={() => _masterSlideLoader.close()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <SideMenu roleId={this.roleId} />
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <BackLinkButton />
                <FormViewMenu submit={this.submit} />
                <div className='contruction-detail-view__bar' />
                <div className='contruction-detail-view__main contruction-detail-view__main--fix contruction-detail-view__main--fixed'>
                  {this.renderConfigMail()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RadioButton = ({ index, name, label, value, onChange, checked }) => {
  return (
    <label className='radio'>
      <input
        type='radio'
        name={name}
        onChange={() => {
          onChange(index, value);
        }}
        value={value}
        checked={checked}
      />
      <RadioButtonIcon className='icon--2x' />
      <span>{label}</span>
    </label>
  );
};

const SideMenu = ({ roleId }) => (
  <div className='contruction-detail-view__sidemenu'>
    <ul className='contruction-navi-list'>
      <li className='contruction-navi-list__item'>
        <div
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileDetail', { state: {} });
          }}
        >
          基本情報
        </div>
      </li>
      {isPrimaryCompanyRoleId(roleId) && (
        <li className='contruction-navi-list__item'>
          <a
            className='line-list line-list--contruction-navi-list'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              _masterSlideLoader.show('UserProfilePhoto', { state: {} });
            }}
          >
            顔写真
          </a>
        </li>
      )}
      <li className='contruction-navi-list__item'>
        <div
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileNotify', { state: {} });
          }}
        >
          通知設定
        </div>
      </li>
      <li className='contruction-navi-list__item'>
        <div className='line-list line-list--contruction-navi-list select'>
          メール受信設定
        </div>
      </li>
    </ul>
  </div>
);

const BackLinkButton = () => (
  <div className='contruction-detail-view__header'>
    <button className='btn-text--sm' onClick={() => _masterSlideLoader.close()}>
      <i className='i-back--blue i-2x vertical-middle' />
      閉じる
    </button>
  </div>
);

class FormViewMenu extends React.Component {
  render() {
    return (
      <div className='contruction-detail-view__menu'>
        <span className='construction-detail-view__button'>
          <button
            className='btn--effective'
            onClick={() => this.props.submit()}
          >
            更新
          </button>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/UserProfileSettingMail.jsx